import { Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  ProjectToInternal,
  useInternalConnectionsContext,
} from '../../InternalConnectionsContext'
import GroupSelect from '../../../GroupSelect'
import { GroupSelectValue } from '../../../GroupSelect/types'
import { useGlobalState } from 'context/GlobalStateContext'
import { useEditProjectToGroupToInternalMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { errorHandler } from 'hooks/errorHandler'

export function useEdit(): EditRowActionOptions<
  ProjectToInternal,
  GroupSelectValue
> {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { refetch, fetching, groups } = useInternalConnectionsContext()
  const [edit] = useEditProjectToGroupToInternalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editProjectToInternalConnection: {
        projectToInternalConnection: { internalConnection },
      },
    }) => simpleEditNotification(internalConnection),
  })
  return {
    permission: Permission.EditPayItemConnection,
    modal: {
      type: 'simple',
      recordName: ({ internal }) => internal.module.name,
      initialValues: ({ group }) => ({
        group: group
          ? { label: group.name, value: group.id, tooltip: group.description }
          : undefined,
      }),
      body: (
        <>
          <GroupSelect loading={fetching} options={groups} />
        </>
      ),
      onOk: async (p2g2i, { group }) => {
        if (group?.value === p2g2i.group?.id) return
        if (!projectId) return errorHandler('projectId is not defined')
        await edit({
          variables: {
            input: {
              internalConnectionId: p2g2i.id,
              projectId,
              groupId: (group?.value as string) ?? null,
            },
          },
        })
        refetch()
      },
    },
  }
}
